const wikiLink =
  'https://decoylabs.notion.site/f304de52d8fe40d7b70548515310836e?v=236a9531beec417a97811dc8a1085287';
export { wikiLink };
